import AdamsJohn from './resources/AdamsJohn';
import BastiatFrederic from './resources/BastiatFrederic';
import CoolidgeCalvin from './resources/CoolidgeCalvin';
import ElyRichardT from './resources/ElyRichardT';
import FranklinBenjamin from './resources/FranklinBenjamin';
import Independence from './resources/Independence';
import JeffersonThomas from './resources/JeffersonThomas';
import LincolnAbraham from './resources/LincolnAbraham';
import LockeJohn from './resources/LockeJohn';
import MadisonJames from './resources/MadisonJames';
import ReaganRonald from './resources/ReaganRonald';
import SchaefferFrancis from './resources/SchaefferFrancis';
import SheenFulton from './resources/SheenFulton';
import TenCommandments from './resources/TenCommandments';
import TocquevilleAlexis from './resources/TocquevilleAlexis';
import WashingtonGeorge from './resources/WashingtonGeorge';
import LibertyBellEmbed from './images/LibertyBellEmbed';



const ResourcesList = {
    tabHeading: 'TLN - Great Quotes',
    metaDescription: `Noteworthy quotes and writings from various Preachers, Politicians, Philosophers and other Influencers.`,
    keywords: ["TrueLibertyNorth", ],
    heading: 'Great Quotes',
    image: LibertyBellEmbed,
    description: `The following is a list of quotes from noteworthy Sermons, Speeches, Books and Teachings taken from various Preachers, Politicians, Philosophers and other 
    Influencers. All of the quotes listed have been traced back to original source material from Reputable Websites. I've done my best to ensure every quote listed is completely 
    legit and verified. That said, it still doesn't hurt to verity further, if you wish to share them with anyone else.`,
    refresh: `Please REFRESH BROWSER for Updated List.`,
    list: [
    AdamsJohn,
    BastiatFrederic,
    CoolidgeCalvin,
    ElyRichardT,
    FranklinBenjamin,
    Independence,
    JeffersonThomas,
    LincolnAbraham,
    LockeJohn,
    MadisonJames,
    ReaganRonald,
    SchaefferFrancis,
    SheenFulton,
    TenCommandments,
    TocquevilleAlexis,
    WashingtonGeorge
    ]
};

export default ResourcesList;